import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { WindowScrollService } from '@campus/browser';
import { ComponentsModule } from '@campus/components';
import { CookiesModule } from '@campus/cookies';
import { MathJaxPipe } from '@campus/shared';
import { SvgModule } from '@campus/svg';
import { UiModule } from '@campus/ui';
import { AboutSectionComponent } from './components/about/about-section.component';
import { BaseFormComponent } from './components/base-form/base-form.component';
import { ContactSectionComponent } from './components/contact/contact-section.component';
import { FaqSectionComponent } from './components/faq/faq-section.component';
import { PortalFooterComponent } from './components/footer/footer.component';
import { HeroSectionComponent } from './components/hero/hero-section.component';
import { MaintenanceModeComponent } from './components/maintenance-mode/maintenance-mode.component';
import { NewsComponent } from './components/news/news.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { NotFoundHeroComponent } from './pages/not-found/components/not-found-hero.component';
import { PageNotFoundComponent } from './pages/not-found/not-found-page.component';
import { AuthService } from './services';
import { DAL_OPTIONS, DalOptions } from './services/api';
import { ApiAuth } from './services/api/internals';
import { CsrfService } from './services/auth/csrf.service';
import { AUTH_SERVICE } from './tokens';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    SvgModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    UiModule,
    BrowserAnimationsModule,
    MatMenuModule,
    RouterModule,
    MatSnackBarModule,
    CookiesModule,
    MathJaxPipe,
  ],
  declarations: [
    HeroSectionComponent,
    FaqSectionComponent,
    AboutSectionComponent,
    VideoPlayerComponent,
    ContactSectionComponent,
    ClickOutsideDirective,
    PageNotFoundComponent,
    NotFoundHeroComponent,
    NewsComponent,
    BaseFormComponent,
    MaintenanceModeComponent,
    PortalFooterComponent,
  ],
  exports: [
    HeroSectionComponent,
    FaqSectionComponent,
    AboutSectionComponent,
    VideoPlayerComponent,
    ContactSectionComponent,
    NotFoundHeroComponent,
    PageNotFoundComponent,
    NewsComponent,
    BaseFormComponent,
    MaintenanceModeComponent,
    PortalFooterComponent,
  ],
  providers: [WindowScrollService, { provide: AUTH_SERVICE, useClass: AuthService }, ApiAuth, CsrfService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PublicPortalModule {
  static forRoot(dalOptions: DalOptions) {
    return {
      ngModule: PublicPortalModule,
      providers: [
        {
          provide: DAL_OPTIONS,
          useValue: dalOptions,
        },
      ],
    };
  }
}
